/**
 * Language configuration for transcription and refinement
 */

export interface Language {
  code: string; // Deepgram/ISO language code
  webSpeechCode: string; // Web Speech API language code
  name: string;
  nativeName: string;
}

export const SUPPORTED_LANGUAGES: Language[] = [
  {
    code: 'en',
    webSpeechCode: 'en-US',
    name: 'English',
    nativeName: 'English',
  },
  {
    code: 'de',
    webSpeechCode: 'de-DE',
    name: 'German',
    nativeName: 'Deutsch',
  },
  {
    code: 'es',
    webSpeechCode: 'es-ES',
    name: 'Spanish',
    nativeName: 'Español',
  },
  {
    code: 'fr',
    webSpeechCode: 'fr-FR',
    name: 'French',
    nativeName: 'Français',
  },
  {
    code: 'it',
    webSpeechCode: 'it-IT',
    name: 'Italian',
    nativeName: 'Italiano',
  },
  {
    code: 'pt',
    webSpeechCode: 'pt-PT',
    name: 'Portuguese',
    nativeName: 'Português',
  },
  {
    code: 'nl',
    webSpeechCode: 'nl-NL',
    name: 'Dutch',
    nativeName: 'Nederlands',
  },
  {
    code: 'pl',
    webSpeechCode: 'pl-PL',
    name: 'Polish',
    nativeName: 'Polski',
  },
  {
    code: 'ru',
    webSpeechCode: 'ru-RU',
    name: 'Russian',
    nativeName: 'Русский',
  },
  {
    code: 'ja',
    webSpeechCode: 'ja-JP',
    name: 'Japanese',
    nativeName: '日本語',
  },
  {
    code: 'ko',
    webSpeechCode: 'ko-KR',
    name: 'Korean',
    nativeName: '한국어',
  },
  {
    code: 'zh',
    webSpeechCode: 'zh-CN',
    name: 'Chinese',
    nativeName: '中文',
  },
];

export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES[0]; // English
